import { useState, useEffect } from 'react';
import { FaPause, FaPlay } from 'react-icons/fa';

const ImagePanel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length);
  };

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 3000);
  
    return () => clearInterval(interval);
  }, [images, isPaused]);

  const togglePause = () => {
    setIsPaused((prev) => !prev);
  };

  return (
    <div className="relative w-full max-w-2xl mt-8 group">
      {/* Slideshow Image */}
      <img
        src={images[currentIndex]}
        alt="Slideshow"
        className="w-full h-auto rounded-lg shadow-lg transition-all duration-700 object-cover"
      />

      {/* Prev & Next Buttons */}
      <button
        onClick={prevSlide}
        className="absolute top-1/2 left-4 transform -translate-y-1/2 blue bg-white bg-opacity-60 p-2 rounded-full shadow hover:bg-opacity-90"
      >
        ❮
      </button>
      <button
        onClick={nextSlide}
        className="absolute top-1/2 right-4 transform -translate-y-1/2 blue bg-white bg-opacity-60 p-2 rounded-full shadow hover:bg-opacity-90"
      >
        ❯
      </button>

      {/* Play/Pause Button (no overlay) */}
      <button
        onClick={togglePause}
        className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition duration-300"
      >
        <div className="bg-gray-200 bg-opacity-70 rounded-full p-2 text-gray-800">
          {isPaused ? <FaPlay /> : <FaPause />}
        </div>
      </button>

      {/* Slide Indicators */}
      <div className="flex justify-center mt-4 gap-2">
        {images.map((_, i) => (
          <div
            key={i}
            onClick={() => setCurrentIndex(i)}
            className={`h-3 w-3 rounded-full cursor-pointer ${
              i === currentIndex ? 'blue-bg' : 'bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default ImagePanel;
